import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import ImageLogo from './tall-logo_ppa.svg';
import BodyTheme from '../bodyTheme';
import FS from '../../services/fullstory.js';
import './homeLanding.scss';

export default class HomeLanding extends Component {

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  componentDidMount() {
    FS.clearUserCookie();
  }

  render () {
    const { query } = this.context.location;
    return (
      <BodyTheme themeClass="dark">
        <div className="container home-landing">
          <div className="text-balloon">
            <h1>Calling all super heroes!</h1>
            <p>
              Part hysterical entertainment, part fun-filled game, and entirely
              focused on <strong>behavior change</strong> and <strong>educational
              outcomes</strong>, the Academy puts kids at the center of the story
              and inspires them to act on real world issues.&nbsp; <strong>
              <a href="http://www.planetprotectoracademy.com" target="_blank">
              Find out more!</a></strong>
            </p>
          </div>
          <h1><img src={ImageLogo} alt="Planet Protector Academy"/></h1>
          <div className="buttons">
            <Link to="/register" query={query} className="btn btn-lg btn-primary btn-wrap register-btn">Register</Link>
            <Link to="/signin" query={query} activeClassName="active" className="btn btn-lg btn-success btn-wrap">Sign in</Link>
          </div>
        </div>
      </BodyTheme>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/landingPage/homeLanding.jsx